import logo from "../assets/gfm-logo-square.png";

export function Logo({ variant = "light", className = "", showName = true }) {
  const dark = variant === "dark";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
      <div className={dark ? "rounded-md bg-white p-1" : ""}>
        <img src={logo} alt="GFM" className="h-[85px] w-[85px] rounded-md object-contain" />
      </div>
      {showName && (
        <div className={`hidden border-l pl-3 font-heading text-sm font-bold leading-tight sm:block ${dark ? "border-white/30 text-white" : "border-border text-brand"}`}>
          Permit to Work<br />Management System
        </div>
      )}
    </div>
  );
}
